import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { FileTypeSourceAdapter } from 'app/model/adapters/activities/copysource/file-type.source.adapter';
import { AzureBlobFSCopySource } from 'app/model/pipeline/copysource/azure-blob-fs.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobFSCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        recursive: '*',
        maxConcurrentConnections: '*'
    }
})
export class AzureBlobFSCopySourceAdapter extends CopySourceAdapter<AzureBlobFSCopySource, Model.AzureBlobFSSource> {
    protected override async _toResource(copySource: AzureBlobFSCopySource): Promise<Model.AzureBlobFSSource> {
        const result: Model.AzureBlobFSSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(AzureBlobFSCopySource).name
        );
        FileTypeSourceAdapter.toSourceResource(copySource, result);
        return result;
    }

    protected override async _toModel(
        blobSource: Model.AzureBlobFSSource,
        copyActivity: CopyActivity
    ): Promise<AzureBlobFSCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureBlobFSCopySource.MODEL,
            blobSource,
            copyActivity
        ) as AzureBlobFSCopySource;
        FileTypeSourceAdapter.toSourceModel(blobSource, result);
        return result;
    }
}
